import { render, staticRenderFns } from "./BaseDepositWithdraw.vue?vue&type=template&id=62d8194a&scoped=true"
import script from "./BaseDepositWithdraw.vue?vue&type=script&lang=js"
export * from "./BaseDepositWithdraw.vue?vue&type=script&lang=js"
import style0 from "./BaseDepositWithdraw.vue?vue&type=style&index=0&id=62d8194a&prod&lang=scss"
import style1 from "./BaseDepositWithdraw.vue?vue&type=style&index=1&id=62d8194a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d8194a",
  null
  
)

export default component.exports